import * as api from "Api";
import * as actions from "Actions";

export const fetchComments = (target, period) => {
  return (dispatch, getState) => {
    let owner = null;
    if (getState().auth.currentOrganization) {
      const { uen } = getState().auth.currentOrganization;
      owner = uen;
    }

    const { token } = getState().auth;

    let data = {
      target,
      owner,
      token,
      period
    };

    dispatch(
      actions.fetchComments(
        api.getComments(data).then(res => {
          return res.data;
        })
      )
    );
  };
};

export const fetchSlidesForComments = () => {
  return (dispatch, getState) => {
    const { uen, id } = getState().auth.currentOrganization;
    let data = {
      uen,
      id
    };
    dispatch(
      actions.fetchAvailableSlide(
        api.getSlidesForComments(data).then(res => {
          return res.data;
        })
      )
    );
  };
};
export const saveComment = (slideCommentId, period) => (dispatch, getState) => {
  const {
    preparePresentation: {
      comment: { target, content }
    },
    dashboard: {
      data: { slides }
    },
    presentation: { currentSlideIndex },
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.saveComment(
      api.saveComment({
        slideCommentId,
        owner: currentOrganization.uen,
        slideCode: slides[currentSlideIndex].code,
        target,
        content,
        period
      })
    )
  );
};

export const saveVoiceComment = (record, period, duration) => (
  dispatch,
  getState
) => {
  const {
    preparePresentation: {
      comment: { target }
    },
    dashboard: {
      data: { slides }
    },
    presentation: { currentSlideIndex },
    auth: { currentOrganization }
  } = getState();

  const voiceFile = record.blob;
  return dispatch(
    actions.saveVoiceComment(
      api.saveVoiceComment({
        owner: currentOrganization.uen,
        slideCode: slides[currentSlideIndex].code,
        target,
        voiceFile,
        duration,
        period
      })
    )
  );
};

export const deleteComments = ids => (dispatch, getState) => {
  return dispatch(actions.deleteComment(api.deleteCommentApi(ids)));
};



// WEBPACK FOOTER //
// ./src/actions/thunks/PreparePresentation.js